import { render, staticRenderFns } from "./Repo.vue?vue&type=template&id=69138552&"
import script from "./Repo.vue?vue&type=script&lang=js&"
export * from "./Repo.vue?vue&type=script&lang=js&"
import style0 from "./Repo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports